import { render, staticRenderFns } from "./POView.vue?vue&type=template&id=05dcf95e&scoped=true&"
import script from "./POView.vue?vue&type=script&lang=js&"
export * from "./POView.vue?vue&type=script&lang=js&"
import style0 from "./POView.vue?vue&type=style&index=0&id=05dcf95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcf95e",
  null
  
)

export default component.exports